<template>
    <v-content>
        <v-row>
            <v-col md="4">
                <v-select v-model="fiscalYearID" dense outlined
                          :items="fiscalYearList"
                          @change="loadItems"
                          item-text="id"
                          item-value="value">
                    <template v-slot:label>
                        {{ $t("fiscal_year") }}
                    </template>
                </v-select>
            </v-col>
            <v-col md="6"></v-col>
            <v-col md="2" style="align-content:end">
                <v-btn color="primary ml-4" @click="viewAll(firstrows)" >{{$t('view All')}}</v-btn>
            </v-col>
        </v-row>
        <vue-good-table mode="remote"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :isLoading.sync="isLoading"
                        :pagination-options="{ enabled: true, }"
                        :rows="firstrows"
                        :columns="columns">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                    <v-btn color="primary ml-4" @click="logBtnData(props.row,props.row.yearID)">{{$t('view')}}</v-btn>
                </span>


                <span v-else-if="props.column.field == 'isQuarterly'">
                    <span v-if="props.row.isQuarterly == true">
                        {{ $t('quater') }}
                    </span>
                    <span v-else>
                        {{ $t('once_a_year') }}
                    </span>
                </span>

                <span v-else>{{props.formattedRow[props.column.field]}}</span>
            </template>

        </vue-good-table>


        <div v-if="table && headers.length>0" id="target-div" ref="targetDiv">
            <span v-if="isLoadedFromServer">Saving...</span>
            <!--<span v-else @click="updateReportData">
            <v-btn v-if="!currentFormApproved" class="float-right mt-10" color="success" style="margin-bottom:10px">
                Save
            </v-btn>
        </span>-->
            <v-btn @click="exportTableToExcel('tblData','('+reportTitle+'_'+valueShow+')',showNextYear?YearPreviousCurrentNext.next:yearShow,reportTitle)" dark class="float-right mt-10 mr-2" color="blue darken-4" style="margin-bottom:10px">
                Export
            </v-btn>
            <h2 style="text-align:center">{{valueShow}} आ.ब.{{showNextYear?YearPreviousCurrentNext.next:yearShow}}  को {{reportTitle}}  </h2>


            <table class="table tbl sticky-table-header">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--NEW-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>
                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">

                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">

                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END-->

                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>


                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>
                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>

                <template v-for="(section,index) in rows">
                    <tr :key="'row1mk'+index">
                        <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                            <span> {{index+1}}. {{section.reportSection}}</span>
                        </td>
                    </tr>
                    <template v-for="(subSection,properindex) in section.list">
                        <tr :key="properindex+'row2lk'+index">
                            <td style="text-align:center">{{properindex+1}}</td>
                            <td style="text-align:center">{{subSection.reportSubSection}}</td>
                            <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                v-for="(rowsHeader, subindex) in subSection.list">
                                <v-text-field dense @keypress="isNumber($event)" label="Amount" outlined
                                              v-if="rowsHeader.dataType==2" v-model="rowsHeader.amount"
                                              v-on:input="calculateTotal()"></v-text-field>
                                <v-text-field dense @keypress="isNumber($event)" label="Quantity" outlined
                                              v-else-if="rowsHeader.dataType==4" v-model="rowsHeader.amount"
                                              v-on:input="calculateTotal()"></v-text-field>
                                <v-text-field dense @keypress="isNumber($event)" label="Quantity 1" outlined
                                              v-else-if="rowsHeader.dataType==6" v-model="rowsHeader.amount"
                                              v-on:input="calculateTotal()"></v-text-field>
                                <v-text-field dense @keypress="isNumber($event)" label="Total" outlined
                                              v-else-if="rowsHeader.dataType==5"
                                              v-model="rowsHeader.amount"></v-text-field>
                                <v-text-field dense label="Text" outlined v-else v-model="rowsHeader.value"></v-text-field>
                            </td>
                        </tr>
                    </template>
                </template>
                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>



            <table class="table tbl" id="tblData" v-show="exportTbl">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>
                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>
                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>

                <template v-for="(section,index) in rows">
                    <tr :key="'row1mk'+index">
                        <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                            <span> {{index+1}}. {{section.reportSection}}</span>
                        </td>
                    </tr>
                    <template v-for="(subSection,properindex) in section.list">
                        <tr :key="properindex+'row2lk'+index">
                            <td style="text-align:center">{{properindex+1}}</td>
                            <td style="text-align:center">{{subSection.reportSubSection}}</td>
                            <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                v-for="(rowsHeader, subindex) in subSection.list">
                                <v-span v-if="rowsHeader.dataType==2">{{rowsHeader.amount}}</v-span>
                                <v-span label="Quantity" outlined
                                        v-else-if="rowsHeader.dataType==4">{{rowsHeader.amount}}</v-span>
                                <v-span label="Quantity1" outlined
                                        v-else-if="rowsHeader.dataType==6">{{rowsHeader.amount}}</v-span>
                                <v-span label="Total" outlined
                                        v-else-if="rowsHeader.dataType==5">{{rowsHeader.amount}}</v-span>
                                <v-span label="Text" outlined v-else>{{rowsHeader.value}}</v-span>
                            </td>
                        </tr>
                    </template>
                </template>
                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>


        <!-----------------and------------------------->


        <div v-if="tableView && headers.length>0">

            <h2 style="text-align:center">{{valueShow}} आ.ब.{{showNextYear?YearPreviousCurrentNext.next:yearShow}}  को {{reportTitle}}</h2>
            <table class="table tbl">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                    आ.ब.  {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->


                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->


                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>
                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">

                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>

                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>


                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>


                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>
            <table class="table tbl" id="tblData" v-show="exportTbl">
                <thead v-if="groupLevel==1 || groupLevel==2">
                    <tr>
                        <th rowspan="2">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                v-if=" header.groupID > 0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ header.groupName }}</span>

                            </th>
                            <template v-else>
                                <template v-for="(column, count) in header.subList">
                                    <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                        <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, secondIndex) in colsHeaders">
                            <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END-->

                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>


                <thead v-if="groupLevel==3">
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <template v-for="(header,index) in headers">
                            <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                v-if="header.groupID>0 ">
                                <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                </span>
                                <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                </span>
                                <!--END-->

                                <span v-else> {{ header.groupName }}</span>
                            </th>
                            <template v-else>
                                <template v-for="(column, subindex) in header.list">
                                    <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                        :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                        <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                        </span>

                                        <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                        </span>
                                        <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ column.name }}</span>
                                    </th>
                                    <template v-else v-for="(subColumn, innerindex) in column.subList">
                                        <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                            <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                            </span>
                                            <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                            </span>
                                            <!--END NEW-->
                                            <span v-else> {{ subColumn.name }}</span>
                                        </th>
                                    </template>
                                </template>

                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column, index) in subColumns">
                            <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                v-if="column.groupID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ column.groupName }}</span>
                            </th>
                            <template v-for="(subColumn, interindex) in column.subList">
                                <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                    v-if="subColumn.titleID>0 && column.groupID==null">
                                    <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                    </span>
                                    <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                    </span>

                                    <!--END NEW-->

                                    <span v-else> {{ subColumn.name }}</span>
                                </th>
                            </template>
                        </template>
                    </tr>
                    <tr>
                        <template v-for="(column,index) in colsHeaders">
                            <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                </span>
                                <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                </span>
                                <!--END NEW-->
                                <span v-else> {{ column.name }}</span>
                            </th>
                        </template>
                    </tr>
                </thead>


                <tfoot>
                    <tr class="tfoot">
                        <td colspan="2"><b>कुल जम्मा</b></td>
                        <td :key="'totalindex'+index" v-for="(total,index) in totals">
                            <b v-if="total!=null">{{total.total}}</b>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>



        <v-dialog max-width="1500px" v-model="dialogView" fullscreen>

            <ViewComponent ref="viewComponent" :viewData="approvedData" @formResponse="onFormResponse"></ViewComponent>

        </v-dialog>
    </v-content>
</template>

<script>
    import axios from "axios";
    import store from "@/store";
    import { mapGetters } from "vuex";
    import ViewComponent from "./ViewComponent";


    export default {
        name: 'LogList',
        watch: {},
        components: {
            ViewComponent
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
        },
        data() {
            return {
                success: false,
                dialogCreate: false,
                dialogEdit: false,
                popout: true,
                viewallReport: false,
                dialogView: false,
                fiscalYearList: [],
                fiscalYearID: 0,
                reportID: 0,
                isLoading: false,
                permissionData: {},
                columns: [
                    {
                        label: "Report Log ID",
                        field: "reportLogID"
                    },
                    {
                        label: "Report ID",
                        field: "reportID"
                    },
                    {
                        label: "Year Name",
                        field: "yearName"
                    },
                    {
                        label: "Report Name",
                        field: "reportName"
                    },
                    {
                        label: 'Level',
                        field: 'level'
                    },
                    {
                        label: 'Budget',
                        field: 'isQuarterly'
                    },
                    {
                        label: "actions",
                        field: "actions"
                    }
                ],
                rows: [],
                firstrows: [],
                approvedData: {},
                totalRecords: 0,
                isLoadedFromServer: false,
                logData: {
                    companyID: 0,
                    departmentID: 0,
                    branchID: 0,
                    depoID: 0,
                    reportID: 0,
                    year: "2081",
                    reportLogID: 0,
                    isActive: null
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                IsActive: false,
                headers: [],
                titleHeaders: [],
                listDatas: [],
                helpData: [],
                listDDLData: [],
                role: "",
                user: {},
                tableView: false,
                table: false,
            };
        },
        mounted() {
            this.getMenu(),
            this.apiData()
        },
        created() {
            this.currentFiscalYear()
        },
        methods: {
            onResponse(data) {
                console.log("yets" + data);
                if (data == true) {
                    this.dialogCreate = false;
                    this.dialogEdit = false;
                    this.loadItems();
                }
            },
            scrollToTargetDiv() {
                if (this.$refs.targetDiv) {
                    this.$refs.targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            },
            searchInput() {
                this.loadItems();
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },


            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage });
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [
                        {
                            type: params[0].type,
                            field: params[0].field
                        }
                    ]
                });
                this.loadItems();
            },
            viewAll(rows) {
                this.dialogView = true
                this.approvedData = rows
                this.$refs.viewComponent.loadData();
            },
            onFormResponse() {
                this.dialogView = false;
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            apiData() {

                axios.get('ReportSettings/DDLOwnReportList').then(response => {
                    this.listDatas = response.data
                })
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.fiscalYearList = response.data
                    this.yearList = response.data
                })
                

            },
            currentFiscalYear() {
                axios.get("ReportSettings/GetCurrentFiscalYear").then(response => {
                    this.fiscalYearID = response.data.value
                    this.loadItems()
                })
            },
            async loadItems() {
                let param = {
                    CompanyID: parseInt(this.usersData.companyID),
                    BranchID: 0,
                    YearID: parseInt(this.fiscalYearID),
                    ReportID: parseInt(this.reportID),
                    DepoID: 0,
                    PageSize: this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                };
                try {
                    const response = await axios.post("ReportSettings/ApprovalBudgetYearList", param);
                    this.firstrows = response.data.data;
                    this.totalRecords = response.data.totalCount;
                } catch (e) {
                    if (e.response.data.State == "AccessTokenExpired") {
                        this.apiResponse(e);
                        this.loadItems();
                    }
                }
                return;
            },
            nullTitle( title ) {
                return title == null
            },
            getMenu() {
                let userData = JSON.parse(store.getters.getInfo);

                this.user.name = userData.userName;
                this.role = userData.role;


            },
            logBtnData(row, year) {
                console.log(row)
                this.logData.companyID = row.companyID
                this.logData.reportLogID = row.reportLogID
                this.helpData = row
                if (this.logData.companyID) {
                    this.getDdlData(this.logData.companyID, 'company');
                    this.logData.branchID = this.helpData.branchID
                    if (this.logData.branchID) {
                        this.getDdlData(this.logData.branchID, 'branch')
                        this.logData.depoID = this.helpData.depoID
                        if (this.logData.depoID) {
                            this.getDdlData(this.logData.depoID, 'depo')
                        }
                    }
                }

                this.logData.departmentID = this.helpData.departmentID
                this.logData.year = year
                if (row.departmentID > 0) {
                    this.valueShow = row.departmentName
                } else if (row.depoID > 0) {
                    this.valueShow = row.depoName
                } else if (row.branchID > 0) {
                    this.valueShow = row.branchName
                } else {
                    this.valueShow = row.companyName
                }
                this.yearShow = row.yearName
                var data = {
                    "reportLogID": parseInt(row.reportLogID),
                    "year": JSON.stringify(year),
                    "departmentID": parseInt(row.departmentID),
                    "depoID": parseInt(row.depoID),
                    "branchID": parseInt(row.branchID),
                    "companyID": parseInt(row.companyID),
                    "reportID": row.reportID,
                    "levelID": row.level,
                    "isQuarterly": row.isQuarterly
                }
                this.serverData = data;
                this.table = true

                this.currentFormApproved = row.isFinalized
                this.getColsRow(this.serverData)
                this.$nextTick(() => {
                    this.scrollToTargetDiv();
                });
            },
            getDdlData(data, val) {

                let formVal = {}
                if (val == "company") {
                    this.listDDLData.branchList = []
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentCompanyList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.branchID = 0
                    this.logData.depoID = 0
                    this.logData.departmentID = 0
                    formVal = {
                        companyID: this.logData.companyID
                    }
                    axios.get("Branch/DDLBranchList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.branchList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentCompanyList = response.data
                    })

                } else if (val == "branch") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.depoID = ""
                    this.logData.departmentID = 0

                    formVal = {
                        branchID: this.logData.branchID
                    }
                    axios.get("Depo/DDLDepoList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.depoList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentBranchList = response.data
                    })


                } else if (val == "depo") {
                    this.listDDLData.departmentDepoList = []
                    this.logData.departmentID = 0

                    formVal = {
                        depoID: this.logData.depoID
                    }
                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentDepoList = response.data
                    })
                }

            },
            getColsRow(data) {
                const currentYearIndex = this.indexWhere(this.yearList, item => item.value === data.year)
                let previousThreeYearIndex = currentYearIndex - 3;
                let previousTwoYearIndex = currentYearIndex - 2;
                let previousYearIndex = currentYearIndex - 1;
                let nextYearIndex = currentYearIndex + 1;
                let previousCurrentNext = {};

                this.yearList.forEach(function (data, yearIndex) {


                    if (currentYearIndex == yearIndex) {
                        previousCurrentNext.current = data.id
                    }
                    //NEW
                    if (previousTwoYearIndex == yearIndex) {
                        previousCurrentNext.twoYear = data.id
                    }
                    if (previousThreeYearIndex == yearIndex) {
                        previousCurrentNext.threeYear = data.id
                    }
                    //end NEW
                    if (previousYearIndex == yearIndex) {
                        previousCurrentNext.previous = data.id
                    }
                    if (nextYearIndex == yearIndex) {
                        previousCurrentNext.next = data.id
                    }

                })
                //data.depoID = data.depoID,
                //    data.branchID = data.branchID,
                //    data.companyID = data.companyID
                //if (data.depoID == "") {
                //    data.depoID = null
                //}

                this.YearPreviousCurrentNext = previousCurrentNext;
                axios.post('ReportSettings/GetApprovalBudgetFinalColsRows', data).then(response => {
                    this.rows = response.data.rows
                    this.headers = response.data.groupedColumns
                    this.totals = response.data.total;
                    this.colsHeaders = response.data.columns;
                    this.reportID = response.data.reportID;
                    this.reportTitle = response.data.reportTitle;
                    this.groupLevel = response.data.groupLevel;
                    this.subColumns = response.data.subColumns;
                    this.showNextYear = response.data.showNextYear;
                })
            },
            indexWhere(array, conditionFn) {
                const item = array.find(conditionFn)
                return array.indexOf(item)
            },
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }
</style>


